import axios from 'axios'

const route = process.env.VUE_APP_API_ROUTE + '/hr_employee'

const fetch = async () => {
    let response = await axios.get(route)
    return response
}

const get = async filtersArray => {
    let query = route + '?'
    filtersArray.forEach(filter => {
        query += 'filter[' + filter.field + ']=' + filter.value + '&'
    })
    query += 'append=discount'
    let response = await axios.get(query)
    return response
}

export default {
    fetch,
    get,
}
